// Func = limiting Scope for this file
var lastScrollTop = 0;

//booking 
var opened = 0;
var start = $('#arriveInput').attr('value');
var end = $('#departureInput').attr('value');

(function(){

	if(document.getElementsByClassName('tolink').length > 0){
		let allToLink = document.getElementsByClassName('tolink');
		for(let link of allToLink){
			link.addEventListener('click', function(e){
				e.preventDefault();
				animateTo(this.getAttribute('href').split('#')[1]);
			});
		}
	}

	$(document).ready(function () {

		$('#content .btn').wrapInner('<span></span>');
		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("changeBg");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("changeBg");
			$('ul.submenu',this).fadeOut(200);
		});


		$('#menu-btn').click(function(event) {
			$('html').addClass('hide-overflow');
			$('.nav-mobile-menu').addClass('open');
			$('.nav-mobile-menu').stop().animate({left:'0px'},{duration:300});
			if($('.nav-mobile-menu ul li a').hasClass('.item-open')){
				$(".item-open").get(0).scrollIntoView(false);
			}
		});

		$('.close-menu').click(function(event) {
			event.preventDefault();
			$('html').removeClass('hide-overflow');
			$('.nav-mobile-menu').removeClass('open');
			$('.nav-mobile-menu').stop().animate({left:'100%'},{queue:false,duration:300});
		});


		// BOOKING
		//To create after event 
		$.datepicker._updateDatepicker_original = $.datepicker._updateDatepicker;
		$.datepicker._updateDatepicker = function (inst) {
			$.datepicker._updateDatepicker_original(inst);
			var afterShow = this._get(inst, 'afterShow');
			if (afterShow)
				afterShow.apply((inst.input ? inst.input[0] : null));  // trigger custom callback
		}
		
		
		$('#bookingCalendar').datepicker({
			changeMonth: false,
			dateFormat: 'mm/dd/yy',
			numberOfMonths: 1,
			minDate:0,
			beforeShowDay: function (date) {

				$.datepicker._defaults.dateFormat = "mm/dd/yy";
				var startDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				var endDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
				if (date.getTime() == startDate.getTime()) {
					return [true, "startday"];
				} else {
					if (date.getTime() == endDate.getTime()) {
						return [true, "endday"];
					} else {
						if (date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime()) {
							return [true, "days"];
						} else {
							return [true, ""];
						}
					}
				}
			},
			onSelect: function (date) {
				var arrive = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				var selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, date);

				if (opened == 0) {
					opened = 1;
					start = date;
					end = date;
					
				} else {
					opened = 0;
					if (selectedDate <= arrive) {
						end = start;
						start = date;
					} else {
						end = date;
					}	
				}

				$('#arriveInput').attr('value',start);
				$('#departureInput').attr('value',end);

			}
			
		});	
		document.getElementById('arriveInput').addEventListener('change', function(){			
			start = this.value;
			$('#bookingCalendar').datepicker("setDate", this.value)
		})
		document.getElementById('departureInput').addEventListener('change', function(){
			end = this.value;
			$('#bookingCalendar').datepicker("setDate", this.value)
		})

		//BOOKING INPUTS animation 
		let bookingInputs = document.getElementById('bookingContainer').getElementsByTagName('input');
		let bookingSelects = document.getElementById('bookingContainer').getElementsByTagName('select');

		for(let i = 0; i < bookingInputs.length; i++){
			bookingInputs[i].addEventListener('focus', function(){
				if(this.type !== 'hidden'){
					this.parentElement.classList.add('moved');
				}
			})
		}
		for(let i = 0; i < bookingSelects.length; i++){
			bookingSelects[i].addEventListener('focus', function(){
				this.parentElement.classList.add('moved');
			})
		}

		document.getElementById('bookingCta').addEventListener('click', function(e){
			e.preventDefault();
			document.getElementById('bookingContainer').classList.add('open')
		})
		document.getElementById('bookingClose').addEventListener('click', function(){
			document.getElementById('bookingContainer').classList.remove('open')
		})





		
		

	//	$("#content .form-module .btn span").contents().unwrap(); 


	

		

			
		// (function() {
		//   var follower, init, mouseX, mouseY, positionElement, printout, timer;
		
		//   follower = document.getElementById('follower');
		
		//   printout = document.getElementById('printout');
		
		//   mouseX = (event) => {
		// 	return event.clientX;
		//   };
		
		//   mouseY = (event) => {
		// 	return event.clientY;
		//   };
		
		//   positionElement = (event) => {
		// 	var mouse;
		// 	mouse = {
		// 	  x: mouseX(event),
		// 	  y: mouseY(event)
		// 	};
		// 	follower.style.top = mouse.y + 'px';
		// 	return follower.style.left = mouse.x + 'px';
		//   };
		
		//   timer = false;
		
		//   window.onmousemove = init = (event) => {
		// 	var _event;
		// 	_event = event;
		// 	return timer = setTimeout(() => {
		// 	  return positionElement(_event);
		// 	}, 1);
		//   };
		
		// }).call(this);



	


		

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
		

	


		// var controller = new ScrollMagic.Controller();
		
		// //parallax-image-intro
		// $(".wrapper-parallax, .animated-img").each(function() {
		//   var tl = new TimelineMax();
		//   var child = $(this).find(".child, img");
		//   tl.to(child, 1, { y: -180, ease: Linear.easeNone });
		
		//   var scene = new ScrollMagic.Scene({
		// 	triggerElement: this,
		// 	triggerHook: 0.4,
		// 	duration: "100%"
		//   })
		// 	.setTween(tl)
		// 	.addIndicators({
		// 	  colorTrigger: "transparent",
		// 	  colorStart: "transparent",
		// 	  colorEnd: "transparent",
		// 	  indent: 10
		// 	})
		// 	.addTo(controller);
		// });





		if (window.matchMedia("(min-width: 900px)").matches) {
			/*****************************************************
		 OBSERVER TO ADD PARALLAX EFFECT
		 /*****************************************************/
		 var scrollParallax = []
		 var scrolled = 0
 
		 // screen height
		 var v_height = window.innerHeight
			 || document.documentElement.clientHeight
			 || document.body.clientHeight;
 
		 function doParallax(elm) {
 
			 let boundes = elm.dataset.parallax.split(",") // get it from html
			 //get distance in positive value
			 let distance = Math.abs(boundes[0] - boundes[1])
			 if (boundes[0] > boundes[1]) {
				 //get distance in negative value (to do the scroll inverse)
				 distance = distance * -1
			 }
			 //Equivalent distance using screen height + element height
			 const unit_scroll = distance / (v_height + elm.offsetHeight)
			 let temp = 0
 
			 let topElement = 0;
			 let element = elm;
 
			 let id_elem = elm.dataset.parallaxid
 
			 do {
				 topElement += element.offsetTop || 0;
				 element = element.offsetParent;
			 } while (element)
 
			 let parallaxFunction = function () {
				 //Obtain the distance between top screen and document top 0
				 scrolled = document.documentElement.scrollTop || window.pageYOffset
				 //Distance of bottom page to top of the element
				 let relative_distance = scrolled + v_height - topElement
				 //transpoling data to move the parallax element relative to the scroll of all the screen
				 temp = (unit_scroll * relative_distance) + parseInt(boundes[0])
				 //console.log('scroll: '+scrolled+' v_height: '+v_height+' element top: '+elm.offsetTop)
				 elm.setAttribute('style', 'transform: translate(0, ' + temp + 'px)')
			 }
 
			 scrollParallax[id_elem] = parallaxFunction
 
			 window.addEventListener('scroll', scrollParallax[id_elem])
 
		 }
 
		 let observers_parallax = document.querySelectorAll(".js-parallax-element")
 
		 if (observers_parallax) {
			 let options_parallax = {
				 root: null, // relative to document viewport
				 rootMargin: '0px', // margin around root. Values are similar to css property. Unitless values not allowed
				 threshold: 0 // visible amount of item shown in relation to root
			 }
 
			 function handler_parallax(entries, observer) {
				 let entry;
				 entries.forEach(function (entry) {
					 if (entry.isIntersecting) {
						 doParallax(entry.target)
					 } else {
						 let id_elem = entry.target.dataset.parallaxid
						 window.removeEventListener('scroll', scrollParallax[id_elem])
					 }
				 })
			 }
 
			 let observable_parallax = new IntersectionObserver(handler_parallax, options_parallax)
			 let counter = 1
			 observers_parallax.forEach(function (element) {
				 observable_parallax.observe(element)
				 element.dataset.parallaxid = counter
				 counter++
			 })
		 }
		 /********************************************************************************
		  END OF OBSERVER TO ADD PARALLAX EFFECT
		  ***********************************************************************************/

		
		  } else {
			
		  }

		

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
		
	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling

	const window_height = window.innerHeight;
	let animatedEl = document.getElementsByClassName('animate-fade-2');
	for (let i = 0; i < animatedEl.length; i++) {
		var viewportOffset = animatedEl[i].getBoundingClientRect();
		let topPos = viewportOffset.top;
		if(topPos <= window_height*0.8){
			animatedEl[i].classList.add('fade-in');
		}
	}

}


//vanilla js scroll animation

function animateTo(target){
	var gotoTarget = offset(document.getElementById(target)).top - 20;
	var from     = window.pageYOffset;
	var to       = gotoTarget;
	var duration = 1300;
	var start = new Date().getTime();

	//time interval
	var timer = setInterval(function() {
		var time = new Date().getTime() - start;

		if(from <= to ){
			var y = easeInOutQuart(time, from, to - from, duration)
		} else {

			var y = easeInOutQuart(time, from, -(from - to), duration)
		}
		window.scrollTo(0, y)
		if (time >= duration) clearInterval(timer)

	}, 1000 / 60);

	window.scrollTo(0, from)

}
//ease movement
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
	return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}
//window offset
function offset(el) {
	var rect = el.getBoundingClientRect(),
		scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
		scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

function titleCase(str) {
	var splitStr = str.toLowerCase().split(' ');
	for (var i = 0; i < splitStr.length; i++) {
		// You do not need to check if i is larger than splitStr length, as your for does that for you
		// Assign it back to the array
		splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
	}
	// Directly return the joined string
	return splitStr.join(' '); 
 }



 let isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;

 if (isMobile) {


 	//SUBNAVIGATION

	// Open active sub-nav on load
	$('.privary-navigation__list ul.submenu li .active').closest('.inner').addClass('open')
	$('.privary-navigation__list ul.submenu li .active').parents().parents('li').addClass('item-open');
	$('.privary-navigation__list ul.submenu li .active').closest('.sub-sub-menu').slideDown(300, function() {}).addClass('menu-open');

	//Toggle open/close on tap
	$('.privary-navigation__list li a').off('click').on('click', function(event) {
		if ( $(this).parent().children(".submenu").length > 0 ) {

            event.preventDefault();

           	if ($(this).next().hasClass('menu-open')) {
	           	$(this).closest('.nav-mobile-menu').removeClass('open');
	            $('.privary-navigation__item ul li').removeClass('item-open');
	            $(this).parent().addClass('item-open');
                $(this).next().slideUp(300, function(){
	                if($('.privary-navigation__item ul li a').hasClass('active')){
						$(".item-open").get(0).scrollIntoView(false);
					} 
                }).removeClass('menu-open');	                
            } else {
	            $(this).closest('.nav-mobile-menu').addClass('open');
	            $('.privary-navigation__item  ul li').removeClass('item-open');
	            $(this).parent().addClass('item-open');
                $('.submenu.menu-open').slideUp(300).removeClass('menu-open'); 
                $(this).next().addClass('menu-open').slideDown(300, function(){
	                if($('.privary-navigation__item  ul li a').hasClass('active')){
						$(".item-open").get(0).scrollIntoView(false);
					}
                });
            }
        }
    });


}
			

